// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__368rC","small":"Icon_small__20Ytu","medium":"Icon_medium__3Of_N","large":"Icon_large__2NGuw","xLarge":"Icon_xLarge__iTZJJ"};